import { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import Container from "../../components/Layout/Container";
import PageTopBanner from "../../components/PageTopBanner";

import { TabsLink } from "../../components/Tab/Tabs";
import { programData } from "../../components/Tab/TabData";

import { Button, PageControlBtns } from "../../components/Button/Button";

import { fetchGet, fetchPost } from "../../hooks/fetch";
import {
  checkLoginAnd,
  getTokenPayload,
  getUserToken,
} from "../../hooks/useLogin";
import { ApplicationType, ApplyStatus, ProgramType } from "./ProgramEnums";
import { openAlert } from "../../components/Modal/MsgBox";
import Loading from "../Loading";

export default function ProgramDetail() {
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("");
  const [isLogin, setIsLogin] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { page, searchText, programType } = location.state || {};

  const handleDataFromChild = (data) => {
    setActiveTab(data);
  };

  const pageName = "프로그램 신청";

  const { id } = useParams();
  const [post, setPost] = useState();

  function goToList() {
    navigate(
      `/program/list?page=${page ?? 1}&searchText=${searchText ?? ""}&programType=${programType ?? ""}`,
    );
  }

  function getProgramData() {
    fetchGet(`/programs/${id}`, (json) => {
      setPost(json);
      setIsLoading(false);
    });
  }

  const nonUserApply = () => {
    if (post.applicationType === "MEMBER") {
      openAlert("회원만 신청이 가능합니다.\n로그인 해 주세요.", () => {
        navigate("/account/login");
      });
    } else if (post.applicationType === "ALL") {
      navigate(`/program/apply/${id}`, {
        state: {
          ...location.state,
          id: id,
          title: post.title,
          summary: post.summary,
        },
      });
    }
  };

  function apply() {
    if (isLogin) {
      checkLoginAnd(
        setIsLogin,
        () => {
          fetchPost(`/programs/user/${id}`, "프로그램을 신청", {});
        },
        nonUserApply,
      );
    } else {
      nonUserApply();
    }
  }

  useEffect(() => {
    setIsLoading(true);
    getProgramData();
    if (getUserToken() !== "" && getTokenPayload().id !== 0) {
      setIsLogin(true);
    }
  }, [isLogin]);

  return (
    <main id="program-page-wrap">
      <h1 className="sr-only">{`${pageName} 페이지`}</h1>

      <PageTopBanner />

      <Container>
        <TabsLink
          className="sub-page-tab-con"
          tabsData={programData}
          activatedTab={activeTab}
          onTabChange={handleDataFromChild}
        />

        <div className="page-content">
          <div className="content-top">
            <div>
              <h1 className="title">{pageName}</h1>
            </div>
          </div>

          <div>
            {post ? (
              <div className="detail-form-con">
                <div className="dv-header">
                  <div className="gs-infos-badge">
                    <div className="info-2">
                      <h2>{post.title}</h2>
                      <p>{post.summary}</p>
                    </div>
                    <div className="info-1">
                      <span
                        className={`condition ${ApplicationType[post.applicationType]?.class}`}
                      >
                        {ApplicationType[post.applicationType]?.str}
                      </span>
                      <span
                        className={`category ${ProgramType[post.programType]?.class}`}
                      >
                        {ProgramType[post.programType]?.str}
                      </span>
                      <span
                        className={`state ${ApplyStatus[post.status]?.class}`}
                      >
                        {ApplyStatus[post.status]?.str}
                      </span>
                    </div>
                    <div className="info-3">
                      <div className="gs-unit pipeline gray">
                        <span>신청기간 : {post.applyPeriod}</span>
                        <span>
                          모집인원 :{" "}
                          {post.recruitmentCount === 0
                            ? "제한 없음"
                            : `${post.recruitmentCount} 명`}
                        </span>
                        <span>교육기간 : {post.educationPeriod}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="dv-body">
                  <div dangerouslySetInnerHTML={{ __html: post?.content }} />
                </div>
              </div>
            ) : isLoading ? (
              <Loading />
            ) : (
              <div className="gs-no-con">해당 게시글을 찾을 수 없습니다.</div>
            )}
          </div>
          <PageControlBtns isBtn onClick={goToList}>
            {post?.status === "ING" && (
              <Button className="gs-btn" onClick={apply}>
                신청하기
              </Button>
            )}
          </PageControlBtns>
        </div>
      </Container>
    </main>
  );
}
